import { Button } from "@shopify/polaris"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { ResetAccessTokenGuide } from "./ResetAccessTokenGuide.jsx"

export const InvalidAccessTokenOverlay = ({ onAccessTokenUpdated }) => {
	const { t } = useTranslation()
	const [showResetAccessTokenGuide, setShowResetAccessTokenGuide] =
		useState(false)

	const openResetPage = () => {
		setShowResetAccessTokenGuide(true)
	}

	const openChat = () => {
		window.$crisp?.push(["do", "chat:open"])
	}

	return (
		<div
			style={{
				position: "fixed",
				top: "0",
				left: "0",
				right: "0",
				bottom: "0",
				height: "100%",
				width: "100%",
				zIndex: "450",
				background: "rgba(0, 0, 0, 0.3)",
				backdropFilter: "blur(5px)",
				display: "flex",
				flexDirection: "column",
				gap: "1rem",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<div
				className="shadow border"
				style={{
					width: "30rem",
					background: "#fff",
					borderRadius: "1rem",
					padding: "1rem",
				}}
			>
				{showResetAccessTokenGuide ? (
					<ResetAccessTokenGuide
						onAccessTokenUpdated={onAccessTokenUpdated}
					/>
				) : (
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "0.5rem",
						}}
					>
						<div
							style={{
								display: "flex",
								gap: "0.5rem",
								alignItems: "center",
							}}
						>
							<svg
								style={{
									width: "1.3rem",
									height: "1.3rem",
									color: "#e61818",
								}}
								viewBox="0 0 256 256"
							>
								<path
									fill="currentColor"
									d="M236.8 188.09L149.35 36.22a24.76 24.76 0 0 0-42.7 0L19.2 188.09a23.51 23.51 0 0 0 0 23.72A24.35 24.35 0 0 0 40.55 224h174.9a24.35 24.35 0 0 0 21.33-12.19a23.51 23.51 0 0 0 .02-23.72M120 104a8 8 0 0 1 16 0v40a8 8 0 0 1-16 0Zm8 88a12 12 0 1 1 12-12a12 12 0 0 1-12 12"
								></path>
							</svg>
							<span
								style={{
									fontWeight: "500",
									fontSize: "1.2rem",
								}}
							>
								{t("error.invalid_access_token_title")}
							</span>
						</div>

						<div
							style={{
								marginTop: "0.5rem",
								marginBottom: "1rem",
							}}
						>
							<span style={{ fontSize: "0.9rem" }}>
								{t("error.invalid_access_token_message")}
							</span>
						</div>

						<Button fullWidth primary onClick={openResetPage}>
							<div
								style={{
									display: "flex",
									gap: "0.3rem",
									alignItems: "center",
								}}
							>
								<span style={{ fontSize: "0.9rem" }}>
									{t("common.reset_access_token")}
								</span>
								<svg
									style={{ height: "1rem", width: "1rem" }}
									viewBox="0 0 24 24"
								>
									<path
										fill="currentColor"
										d="M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42c.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41l-6.58-6.6a.996.996 0 1 0-1.41 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1"
									></path>
								</svg>
							</div>
						</Button>
						<Button fullWidth onClick={openChat}>
							{t("common.contact_us")}
						</Button>
					</div>
				)}
			</div>
		</div>
	)
}
